import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import { INavItems } from '../../../../models/try2Combo';
import * as CONSTANT from '../../../../constants';
import styleClasses from '../../try2.module.scss';

const NavItems: React.FC<INavItems> = ({
  categories,
  selectedCategories,
  itemState,
}) => {
  const onNavClick = () => {
    itemState(false)
  }
  return (
    <Container>
      <Nav variant="pills" className={`${styleClasses.nav_wrap} justify-content-center`}>
        {categories?.map((category) => {
          const selected = selectedCategories.find(
            (ctg) => ctg.category_id == category.id
          );
          return (
            <Nav.Item
              key={category.id}
              className={`${styleClasses.nav_item} shadow-box ${
                selected && 'selected'
              }`}
            >
              <Nav.Link
                eventKey={category.id}
                className={styleClasses.Menu_item_wrap}
                onClick={!selected && onNavClick}
              >
                <img
                  src={`${
                    CONSTANT.REACT_APP_CLOUD_FRONT
                  }/images/Menu/${category.name?.toLocaleLowerCase()}.webp`}
                  className={`${styleClasses.menu_img} img-fluid`}
                  alt={category.name}
                />
                <h6 className="h-18 text-uppercase">{category.name}</h6>
              </Nav.Link>
            </Nav.Item>
          );
        })}
      </Nav>
    </Container>
  );
};

export default NavItems;
